<app-colored-dropdown-menu-button
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  [buttonBackgroundClass]="buttonBackgroundClass"
  [buttonBorderClass]="buttonBorderClass"
  [radius]="radius"
  [buttonIcon]="buttonIcon"
  [isReadOnly]="isReadOnly"
  [tooltip]="tooltip"
  [tooltipPlacement]="tooltipPlacement"
  [verticalSize]="verticalSize"
  [isOpen]="isOpen"
  [keepTooltipOnOver]="!isReadOnly"
  [arrowEnabled]="arrowEnabled"
  [tooltipClasses]="tooltipClasses"
>
  {{ buttonText | translate }}
</app-colored-dropdown-menu-button>

<mat-menu #menu="matMenu" xPosition="after" [class]="'colored-menu'">
  <app-dropdown-options-backdrop class="colored-menu">
    <div class="overflow-y-auto {{ maxHeightClass }}">
      @for (menuAction of menuActions; track $index) {
        <app-dropdown-option
          [attr.data-test-id]="menuAction?.id"
          [menuAction]="menuAction"
          [context]="context"
        ></app-dropdown-option>
      }
    </div>
    <ng-content select="[slot='dropdown-footer']"></ng-content>
  </app-dropdown-options-backdrop>
</mat-menu>
